// Deve ser o primeiro import: propaga o nonce de CSP para estilos
// injetados em runtime (Vuetify, FullCalendar etc.)
import '@/utils/cspNonce'

import { initTheme } from '@/utils/theme'
initTheme() // aplicar tema salvo o mais cedo possível, antes do Vue bootar

import Vue from 'vue'
import Vuetify from 'vuetify'
import VueFullscreen from 'vue-fullscreen'

import '@/plugins/_'
import '@/components/_'
import '@/filters/_'
import '@/directives/directives'

import router from '@/router/_'
import store from '@/store/index'
import App from './App.vue'
import '@mdi/font/css/materialdesignicons.css'
import 'line-awesome/dist/line-awesome/css/line-awesome.css'
import 'bootstrap/dist/css/bootstrap.css'
import 'tippy.js/dist/tippy.css'

const ignoreWarnMessage: string[] = [
  'The .native modifier for v-on is only valid on components but it was used on <div>.',
  'The specified value "Invalid date" does not conform to the required format, "yyyy-MM-dd".',
  'WebSocket connection to \'ws://localhost:3000/sockjs-node/783/swlicjbx/websocket\' failed: WebSocket is closed before the connection is established.',
  'The specified value "Invalid date" does not conform to the required format.  The format is "HH:mm", "HH:mm:ss" or "HH:mm:ss.SSS" where HH is 00-23, mm is 00-59, ss is 00-59, and SSS is 000-999.',
  'TypeError: Cannot read property \'insertBefore\' of null',
  'TypeError: Cannot read properties of null (reading \'style\')',
]

Vue.config.warnHandler = (msg: any, vm: any, trace: any) => {
  if (ignoreWarnMessage.includes(msg)) {
    // eslint-disable-next-line
    msg = null
    // eslint-disable-next-line
    vm = null
    // eslint-disable-next-line
    trace = null
  }
}

// Vue.config.errorHandler = (msg: any, vm: any, trace: any) => {
//   if (ignoreWarnMessage.includes(msg)) {
//     // eslint-disable-next-line
//     msg = null
//     // eslint-disable-next-line
//     vm = null
//     // eslint-disable-next-line
//     trace = null
//   }
// }

Vue.config.productionTip = false

Vue.use(Vuetify, {
  iconfont: ['mdi', 'la'],
})

Vue.use(VueFullscreen)

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#finxapp')
